<template>
  <div class="ds-flex ds-justify-center">
    <AkPagination
      v-if="shouldShowPagination"
      :current-page="currentPage"
      :last-page="lastPage"
      class="ds-mt-4 ds-gap-2"
      data-testid="mediaLibraryPagination"
      @change="handleChangePage"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AkPagination } from '@ankorstore/design-system';
import type { MediaResponse } from '../../types';

const props = defineProps<{
  pagination: MediaResponse['meta']['page'];
}>();

const emit = defineEmits(['change']);

const shouldShowPagination = computed(() => {
  return props.pagination && (props.pagination.total > props.pagination.perPage);
});

const currentPage = computed(() => {
  return Math.ceil(props.pagination.from / props.pagination.perPage);
});

const lastPage = computed(() => {
  return Math.ceil(props.pagination.total / props.pagination.perPage);
});

const handleChangePage = (page: number) => {
  emit('change', page);
};
</script>